import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import AppLayout from "../../components/layout/AppLayout";
import Breadcrumb from "../../components/layout/Breadcrumb";
import ItemForm, { itemPayload } from "../../components/items/ItemForm";
import { pageTitleClass } from "../../components/ui/styles";
import { useAppDispatch } from "../../app/hooks";
import {
  fetchItemCategoriesData,
  fetchItemMaterialsData,
  fetchItemSizesData,
} from "../../features/items/itemsSlice";
import { POST } from "../../services/axios.service";
import { route } from "../../static/route";
import { toastStyles } from "../../static/styles";
import { BreadcrumbType } from "../../types/common";
import { IFormInput } from "../../types/item";

const breadcrumbItems: BreadcrumbType[] = [
  { label: "હોમ", href: route.dashboard },
  { label: "આઈટમ્સ", href: route.items },
  { label: "નવી આઇટમ" },
];

const ItemCreatePage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    dispatch(fetchItemCategoriesData());
    dispatch(fetchItemMaterialsData());
    dispatch(fetchItemSizesData());
  }, [dispatch]);

  const handleGoBack = () => {
    navigate(route.items);
  };

  const handleSubmit = async (data: IFormInput) => {
    setIsSubmitting(true);
    try {
      await POST("/v1/admin/items", itemPayload(data))
        .then((response: any) => {
          if (response.data.status === "success") {
            toast.success(response.data.message, {
              ...(toastStyles as any),
            });
            navigate(route.items);
          } else {
            toast.error(response.data.message, {
              ...(toastStyles as any),
            });
          }
        })
        .catch((error: any) => {
          toast.error(error.data.message, {
            ...(toastStyles as any),
          });
        });
    } catch (error) {
      toast.error("કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.", {
        ...(toastStyles as any),
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppLayout>
      <div className="mb-2 md:mb-0">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <div className="flex items-center mb-4 md:mb-6 mt-2">
        <h1 className={pageTitleClass}>નવી આઇટમ ઉમેરો</h1>
      </div>

      <div className="flex flex-col gap-6">
        <ItemForm
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          onCancel={handleGoBack}
        />
      </div>
    </AppLayout>
  );
};
export default ItemCreatePage;
